const { lang } = window;

const MAZState = val => {
  if (!val) return lang.t('cos.MAZ_state.Off');
  val = val.toString();
  return lang.t('cos.MAZ_state')[val];
};

const StorageClassText = val => {
  if (!val) return '';
  val = val.toString();
  return lang.t('cos.storage_class_map')[val];
};
const StorageClassShortText = val => {
  if (!val) return '-';
  val = val.toString();
  return lang.t('cos.storage_class_short_map')[val];
};

const ObjectAclText = val => {
  let aclText = '';
  if (!val) return aclText;
  val = val.toString();

  if (/^tce-.*/.test(val)) {
    val = val.replace(/^tce-/, '');
    aclText = val === 'default'
      ? lang.t('cos.acl_map.tce-default')
      : lang.t(`cos.acl_map.${val || 'private'}`);
  } else {
    aclText = lang.t(`cos.acl_map.${val || 'private'}`);
  }
  return aclText;
};

export default {
  MAZState,
  StorageClassText,
  ObjectAclText,
  StorageClassShortText,
};
